import gql from 'graphql-tag';

export const WAREHOUSE_FRAGMENT = gql`
  fragment WarehouseFragment on Warehouse {
    createdAt
    createdBy
    id
    internalId
    isActive
    isLocalCarrier
    name
    updatedAt
    updatedBy
  }
`;

export const WAREHOUSE_FIND_MANY = gql`
  query WarehouseFindMany(
    $orderBy: [WarehouseOrderByWithRelationInput!]
    $skip: Int
    $take: Int
    $where: WarehouseWhereInput
  ) {
    WarehouseFindMany(
      orderBy: $orderBy
      skip: $skip
      take: $take
      where: $where
    ) {
      ...WarehouseFragment
    }
  }
  ${WAREHOUSE_FRAGMENT}
`;
